// Axios
import { serverAPI } from '../../index'

import { changeHeaderVisible } from '../Header/actions'
import { profile } from '../ProfilePage/actions'

import _ from 'lodash'

// Action types
export const CHANGE_OPERATIONS = 'change_operations'
export const CHANGE_SWAP_SEARCH = 'change_swap_search'

export const changeOperations = (operations) => {
  return {
    type: CHANGE_OPERATIONS,
    payload: operations
  }
}

export const changeSwapSearch = (search) => {
  return {
    type: CHANGE_SWAP_SEARCH,
    payload: search
  }
}

export const fetchOperations = (userId) => {
  return dispatch => {
    serverAPI.get('/user/groups', { userId })
      .then(response => {
        dispatch(changeOperations(response.data))
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export const pinOperation = (userId, id, pin, type) => {
  return dispatch => {
    if (pin) {
      pin = '1'
    }
    else {
      pin = '0'
    }
    serverAPI.post('/user/pin-operation', { userId, operationId: id, pin, type })
      .then(response => {
        dispatch(fetchOperations(userId))
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export const swapOperation = (data, userId, history) => {
  return dispatch => {
    if (!_.isEmpty(data)) {
      dispatch(changeSwapSearch(''))
      dispatch(profile(data, true, history))
      // dispatch(fetchOperations(userId))
    }
  }
}